<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/areaconhecimento"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaoareaconhecimento }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorareaconhecimento"
      :novo="novaAreaConhecimento"
      :editar="editarAreaConhecimento"
      :excluir="excluirAreaConhecimento"
      :cancelar="cancelarAreaConhecimento"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaDisciplina">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <Input type="text" label="Código da Área de Conhecimento" v-model="form.identificadorareaconhecimento" disabled />
          <Input type="text" label="Descrição da Área de Conhecimento" ref="focusCampo" v-model="form.descricaoareaconhecimento" :disabled="acao == ''" :v="$v.form.descricaoareaconhecimento" />
          <!--Input type="datetime-local" placeholder="dd/mm/aaaa hh" label="Data e hora do Cadastro" disabled :value="adaptarData()" :v="$v.form.datahoracadastro"/-->
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadorareaconhecimento: '',
  descricaoareaconhecimento: '',
  datahoracadastro: '',
});

export default {
  name: 'AreaConhecimento',
  components: {
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaoareaconhecimento',
      buscaOptions: [
        { value: 'identificadorareaconhecimento', text: 'Código' },
        { value: 'descricaoareaconhecimento', text: 'Descrição' },
      ],
      formUltimo: {},
    };
  },
  validations: {
    form: {
      descricaoareaconhecimento: {
        required, alphaSpace, maxLength: maxLength(100), minLength: minLength(4),
      },
    },
    /*   GAMBIARRA
           A regra de validação abaixo foi inserida apenas para corrigir um pequeno erro na interface de usuário que ocorre quando o botão cancelar é usado.

           Quando a última regra de validação declarada não é válida, a validação impede que o botão cancelar seja executado.
           Porém, quando a última regra é válida, o erro não ocorre.
           Nesse caso, como nesta tela só há um campo sendo validado e ele não está válido quando o botão cancelar é clicado,
           é necessário lançar uma regra vazia abaixo somente para evitar de o erro ocorrer.
    */
    submitText: {}
  },
  methods: {
    tabelaDisciplina() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Área de Conhecimento / Listar',
          rota_api: 'gerencial/areaconhecimento/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorareaconhecimento', sortable: false },
						          { text: 'Descrição', value: 'descricaoareaconhecimento', sortable: false }],
        },
      });
    },
    novaAreaConhecimento() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarAreaConhecimento() {
      this.acao = 'editar';
    },
    cancelarAreaConhecimento() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirAreaConhecimento() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta área de conhecimento?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/areaconhecimento/${this.form.identificadorareaconhecimento}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },

    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      api({
        method: (this.acao === 'novo') ? 'post' : 'put',
        url: `gerencial/areaconhecimento${(this.acao === 'novo') ? '' : `/${this.form.identificadorareaconhecimento}`}`,
        data: this.form,
      }).then((response) => {
        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...response.data.results };
      }).catch((error) => {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
    adaptarData() {
      if (this.form.datahoracadastro) { return this.form.datahoracadastro.replace(' ', 'T').substring(0, 19); }
    },
  },
};
</script>

<style>

</style>
